var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-mt-md u-mb-md"},[_c('section',[_c('AppTitle',{staticClass:"u-mb-0",attrs:{"title":_vm.$t('mantra')}})],1),_c('section',{staticClass:"u-mt-md"},[_c('Query',{attrs:{"query":require('~/graphql/Career.gql').Careers,"limit":6,"initialValue":_vm.careers,"variables":function (ref) {
	var first = ref.first;
	var after = ref.after;

	return ({ first: first, after: after, isPublished: true, isArchived: false });
}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return _vm._l((items),function(career,idx){return _c('CareersCard',{key:idx,attrs:{"data":career}})})}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }